import * as React from "react";
const SvgFiRrWifiAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-wifi-alt_svg__a)">
      <path
        fill="#062147"
        d="M11 23a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4.535-2.122a1 1 0 0 0 0-1.414 5 5 0 0 0-7.07 0 1 1 0 0 0 1.414 1.414 3.074 3.074 0 0 1 4.242 0 1 1 0 0 0 1.414 0m2.83-2.828a1 1 0 0 0 0-1.414 9.01 9.01 0 0 0-12.729 0A1 1 0 0 0 7.05 18.05a7.01 7.01 0 0 1 9.9 0 1 1 0 0 0 1.414 0M5.986 22.16a1 1 0 0 0-.826-1.147 3.81 3.81 0 0 1-3.124-2.94A3.47 3.47 0 0 1 3.86 14.48a2 2 0 0 0 .805-2.69 6 6 0 1 1 11.06-4.514 3.1 3.1 0 0 0 2.044 2.052 5.97 5.97 0 0 1 4.212 6.21 5.69 5.69 0 0 1-3.41 4.726 1 1 0 0 0 .858 1.806 7.64 7.64 0 0 0 4.547-6.376 7.96 7.96 0 0 0-5.62-8.277 1.09 1.09 0 0 1-.722-.734 8 8 0 0 0-15.489.84 7.78 7.78 0 0 0 .778 5.19 5.45 5.45 0 0 0-2.866 5.642 5.83 5.83 0 0 0 4.782 4.632 1 1 0 0 0 1.148-.826"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-wifi-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWifiAlt;
